"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalColumnLink = void 0;
const react_1 = __importDefault(require("react"));
const atoms_1 = require("../atoms");
const ExternalColumnLink = ({ link = {}, locale }) => {
    if (!link)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(atoms_1.NavLink, { link: link, className: "external-link", locale: locale },
            react_1.default.createElement(atoms_1.Heading3, null,
                link.title,
                link.arrowIcon ? react_1.default.createElement(atoms_1.ArrowIcon, { face: "upright", relative: true }) : "")),
        link.description && react_1.default.createElement(atoms_1.Paragraph, { caption: true }, link.description)));
};
exports.ExternalColumnLink = ExternalColumnLink;
//# sourceMappingURL=ExternalColumnLink.js.map